import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { Entity } from '@app/core/model/entities/entity';
import { Transform, Type } from 'class-transformer';
import dayjs, { Dayjs } from 'dayjs';

export enum ActionTypeEnum {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  MANUAL = 'MANUAL'
}

export enum ServiceEnum {
  RETOOL = 'RETOOL'
}

export enum ManualWorkflowViewEnum {
  GRID = 'GRID',
  SIDEPANEL = 'SIDEPANEL',
  SHEET = 'SHEET'
}

export class Workflow extends Entity {
  public declare id: number;
  public objectType = EntityTypeEnum.WORKFLOW;
  public organizationId: string;
  public service: ServiceEnum;
  public entityType: EntityTypeEnum;
  public trigger: ActionTypeEnum;
  public url: string;
  public config: ConfigObject;
  public queryParams: Record<string, string>;

  @Transform(fn => dayjs(fn.value), {toClassOnly: true})
  @Type(() => String)
  public lastExecutedAt: Dayjs | null;
}

type ConfigObject = {
  updateFields?: string[],
  btnParams?: {label: string, views: string[], requiresEntitySelection: boolean}
};

export interface WorkflowInput {
  name: string;
  service?: ServiceEnum;
  entityType: EntityTypeEnum;
  trigger: ActionTypeEnum;
  url: string;
  headers?: {name: string; value: string}[];
  config: Record<string, any>;
  queryParams: Record<string, string>;
}
